import {
  TrainingCourseJobModel,
  TrainingCourseJobModelHttp,
  TrainingCourseJobModelWizard,
} from '@data/models/training-course-job-model.interface';

export const toTrainingCourseJobModel = ({
  attributes,
  id,
}: Partial<TrainingCourseJobModelHttp>): TrainingCourseJobModel => {
  return {
    id: id || '',
    code: attributes?.code || 0,
    label: attributes?.label || '',
  };
};

export const toTrainingCourseJobModelWizard = (
  jobModel: TrainingCourseJobModel,
  trainingCourseId: string,
): TrainingCourseJobModelWizard => {
  return {
    type: 'training_course_job_models',
    id: jobModel.id || '',
    attributes: {
      code: jobModel.code,
      label: jobModel.label,
    },
    relationships: {
      training_course: {
        data: {
          type: 'training_courses',
          id: trainingCourseId,
        },
      },
    },
  };
};
